module.exports = __webpack_public_path__ + "img/nocoll.5d2bf32d.png";